import React, { useEffect, useState } from 'react';
import { Button, Modal, Col, Stack, Row, Form } from 'react-bootstrap';

export default function KalkulusIndexButtonModal({
    visibleOdontogramKalkulus,
    setVisibleOdontogramKalkulus,
    activeIndex,
    setActiveIndex

}) {
    const isActive = activeIndex === "kalkulus";
    const handleClick = () => {
        if (isActive) {
            setActiveIndex("");
        } else {
            setActiveIndex("kalkulus");
        }
    };
    return (
        <>
            <Button
                variant={isActive ? "success" : "primary"}
                size="sm"
                onClick={handleClick}
                className="w-100"
            >
                Kalkulus Index
            </Button>
            {/* {visibleOdontogramKalkulus &&
                <>
                    <Button
                        variant={visibleOdontogramKalkulus ? "primary" : "success"}
                        size="sm"
                        onClick={() => setVisibleOdontogramKalkulus(true)}
                        className='w-100'
                    >
                        Kalkulus Index
                    </Button>
                </>
            } */}
        </>
    )
}
